import React from "react";

const CustomSection = ({ title, children }) => {
  return (
    <section className="mb-6">
      <h3 className="text-xl font-semibold mb-2 text-slate-600">{title}</h3>
      <p className="text-gray-700 leading-relaxed text-sm">{children}</p>
    </section>
  );
};

export default CustomSection;